var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"f-56"},[_c('div',{directives:[{name:"bg",rawName:"v-bg"}],staticClass:"content",attrs:{"bg-url":require("@/v2/auto/assets/image/56/0.jpg")}},[_c('div',{staticClass:"title f-center-title"},[_vm._v("多脑并行，每个音区都有专属 AI 助理")]),_c('div',{staticClass:"f-center-sub-title"},[_vm._v(" 主驾、副驾、后排都可同时唤起 AI 小窗，探索自己的 AI 玩法 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }